import React from "react";

function VideoCameraSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="12"
      fill="none"
      viewBox="0 0 16 12"
    >
      <path
        fill="#111928"
        stroke="#111928"
        strokeWidth="1.5"
        d="M12.888 3.777h0l2-1A.25.25 0 0115.25 3v6a.25.25 0 01-.362.223l-2-1h0A.25.25 0 0112.75 8V4a.25.25 0 01.138-.223zM.75 2A1.25 1.25 0 012 .75h6A1.25 1.25 0 019.25 2v8A1.25 1.25 0 018 11.25H2A1.25 1.25 0 01.75 10V2z"
      ></path>
    </svg>
  );
}

export default VideoCameraSvg;
